import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!

  return (_openBlock(), _createBlock(_component_CardTable, {
    ref: "tableRef",
    name: "Node",
    endpoint: `location/service-point`,
    header: $setup.tableHeader,
    customEdit: true,
    customProperties: $setup.customProperties,
    hasQueryParam: false,
    endPointWithOutQuery: "location/service-point",
    loadingProp: _ctx.loading,
    modelValue: _ctx.tableData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableData) = $event)),
    hasDynamicBreadcrumbs: true,
    breadcrumbs: _ctx.breadcrumbs,
    filterData: $setup.filterData,
    showSearch: false
  }, _createSlots({
    "cell-province": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(row.province?.name || '-'), 1)
    ]),
    "cell-edit": _withCtx(({ row }) => [
      _createVNode(_component_router_link, {
        to: `/location/node/${row.id}`,
        class: "menu-link px-3"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    create: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: "/location/add-node",
        class: "btn btn-success me-4"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    _renderList($setup.loopers.filter((data) => ![].includes(data.key)), (item, i) => {
      return {
        name: `cell-${item}`,
        fn: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row[item]), 1)
        ])
      }
    })
  ]), 1032, ["header", "customProperties", "loadingProp", "modelValue", "breadcrumbs", "filterData"]))
}